var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnisizeDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45312 4.94092L4.45313 12.9369L11.4896 12.9369L11.4896 4.94092",
    stroke: "white",
    strokeWidth: 0.774276
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01074 5.58105L7.01074 11.3382",
    stroke: "white",
    strokeWidth: 0.774276
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93066 5.58105L8.93066 11.3382",
    stroke: "white",
    strokeWidth: 0.774276
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.809 3.3418L4.13281 3.3418",
    stroke: "white",
    strokeWidth: 0.774276
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69141 2.0625L9.25014 2.0625",
    stroke: "white",
    strokeWidth: 0.774276
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnisizeDelete);
export default __webpack_public_path__ + "static/media/unisize_delete.fb65ded4b91ac32a79a0c7c946d6af7d.svg";
export { ForwardRef as ReactComponent };